import { observable, action } from 'mobx';
import { toast } from "react-toastify";
import ICategory from "../../types/ICategory";
import ICategoryService from "../../services/spi/ICategoryService";
import FirebaseCategoryService from "../../services/impl/firebase/FirebaseCategoryService";

const BlankCategory = {
  uid: '',
  name: '',
  status: true,
  categoryCode: "",
  visible: true,
  editable: true,
  lastUpdatedOn: '',
  lastUpdatedBy: '',
  displayOrder: 0,
  createdOn: new Date().toDateString(),
};

class CategoryStore {
  rootStore: any = null;
  categoryService = {} as ICategoryService;

  @observable categories = [] as Array<ICategory>;
  @observable category:ICategory = {
    uid: '',
    name: '',
    status: true,
    lastUpdatedOn: '',
    lastUpdatedBy: '',
    displayOrder: 0,
    categoryCode: '',
    visible: true,
    editable: true,
    createdOn: new Date().toDateString(), 
  };

  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.categoryService = new FirebaseCategoryService();
  }

  @action getCategories = async() => {
    this.categories = await this.categoryService.getCategories();
  }

  @action setAttribute = (attrName:string, attrValue:string) => {
    switch (attrName) {
      case 'name':
        this.category.name = attrValue
        this.category.categoryCode = this.category.name.replace(/\s+/g, '-').toUpperCase();
        return;
      case 'categoryCode':
        return this.category.categoryCode = attrValue;
      default:
        return;
    }
  }

  @action setBooleanAttributes = (attrName:string, attrValue:boolean) => {
    if (attrName == 'status')
      this.category.status = attrValue;
  }

  @action setIntegerAttributes = (attrName: string, attrValue: number) => {
    if (attrName === "displayOrder") {
      this.category.displayOrder = attrValue
    }
  }

  @action setBlankCategory = () => {
    this.category = BlankCategory;
  }

  @action setCategory = (data:ICategory) => {
    this.category = data;
  }

  @action saveCategory = async() => {
    const { uid } = this.category;
    try{
      if (uid) {
        await this.categoryService.updateCategory(this.category);
        toast.success("Category Updated Successfully!");
      } else {
        await this.categoryService.createCategory(this.category);
        toast.success("Category Added Successfully!");
      }
      this.categories = await this.categoryService.getCategories();
    } catch(err) {
      toast.error("Error Saving Category!");
    }
  }

  @action deleteCategory = async (uid: string) => {
    // Delete Call Here
    toast.success("Category Deleted Successfully!");
  }

}

export default CategoryStore;
